export const pluralize = (count: number, word: string): string =>
  `${word}${Number(count) > 1 ? "s" : ""}`;
